import { type BUILD_ENV_TYPE } from "@web3auth/auth";

import buildEnv from "@/config-build";

const environment = import.meta.env.VITE_BUILD_ENV as BUILD_ENV_TYPE;
const currentBuildEnv = buildEnv[environment];

const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION ? `v${import.meta.env.VITE_BUILD_VERSION.split(".")[0]}` : "";
const CAPTCHA_SITE_KEY = import.meta.env.VITE_CAPTCHA_SITE_KEY as string;

export default {
  version: BUILD_VERSION,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string,
  buildEnv: environment,
  ...currentBuildEnv,
  captchaSiteKey: CAPTCHA_SITE_KEY,
};
